'use client';
import React, { useEffect } from 'react';
import styled from '@benzinga/themetron';
import { CallToAction, CallToActionProps } from '@benzinga/ui';
import Link from 'next/link';
import { EdgeBadge } from '@benzinga/core-ui';

export interface MoneyHeaderLayout4Props {
  background_image: string;
  campaign?: CallToActionProps;
  description?: string;
  services?: {
    service_img?: string;
    title: string;
    url: string;
  }[];
  subtitle?: string;
  title: string;
  is_ranking_screener?: boolean;
}

export const MoneyHeaderLayout4 = ({
  background_image,
  campaign,
  description,
  is_ranking_screener = false,
  services,
  subtitle,
  title,
}: MoneyHeaderLayout4Props) => {
  const [currentPageURL, setCurrentPageURL] = React.useState<string>('');
  useEffect(() => {
    setCurrentPageURL(window.location.pathname);
  }, []);

  return (
    <MoneyHeaderLayout4Wrap>
      <img className="header-cover" src={background_image} />
      <div className="block-content-wrapper ">
        <div className="flex text-white flex-col md:flex-row gap-4 py-8">
          <div className={`${campaign ? 'md:w-8/12' : 'w-full'}`}>
            <div className="flex items-center gap-8 mb-4">
              <h2 className="mb-0">{title}</h2>
              <span className="scale-150 pr-4 md:pr-0 flex-shrink-0">{EdgeBadge}</span>
            </div>
            {subtitle && <h3 className="text-white mb-4">{subtitle}</h3>}
            {description && <p className="mb-4">{description}</p>}
            {is_ranking_screener && (
              <Link className="text-white font-bold hover:underline text-lg" href="/screener">
                Use Benzinga's stock screener to discover more top stocks.
              </Link>
            )}
          </div>
          {campaign && (
            <div className="md:w-2/6">
              <CallToAction
                button_text={campaign.button_text}
                description={campaign.description}
                disclosure={campaign?.disclosure ?? ''}
                id={campaign.id}
                image_url={campaign?.image_url}
                layout={'vertical'}
                title={campaign.title}
                url={campaign.url}
              />
            </div>
          )}
        </div>
        {Array.isArray(services) && services.length > 0 && (
          <ul className="sub-pages-link inline-flex gap-4 flex-col md:flex-row">
            {services.map((item, i) => {
              const itemURL = item.url.replace('https://www.benzinga.com', '');
              return (
                <li className={currentPageURL == itemURL ? `active` : ''} key={item.title + i}>
                  <a href={item.url} key={item.title + i}>
                    {item.title}
                  </a>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </MoneyHeaderLayout4Wrap>
  );
};

const MoneyHeaderLayout4Wrap = styled.div`
  h2 {
    font-size: 2.5rem;
    line-height: 1.2;
    font-weight: 700;
    color: #ffffff;
  }
  .sub-pages-link {
    li {
      background: #192940;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      @media screen and (max-width: 767px) {
        border-radius: 5px;
        &:last-of-type {
          margin-bottom: 1rem;
        }
      }
      &.active,
      &:hover {
        background: #4083f8;
        transition: 0.4s;
      }
      a {
        display: block;
        padding: 8px 12px;
        color: white;
        font-weight: 500;
      }
    }
  }
`;
